import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class GradeService {
    token = localStorage.getItem('token');

    constructor(private http: HttpClient) { }

    private _gradesData = new BehaviorSubject<boolean>(false);
    gradesData = this._gradesData.asObservable();

    setGradesReload() {
        this._gradesData.next(true);
    }

    getGradesReload() {
        return this._gradesData;
    }

    private _gradeData = new BehaviorSubject<any>(null);
    gradeData = this._gradeData.asObservable();

    setGradeData(grade) {
        this._gradeData.next(grade);
    }

    getGradeData() {
        return this._gradeData;
    }

    private _classData = new BehaviorSubject<any>(null);
    classData = this._classData.asObservable();

    setClassData(clazz) {
        this._classData.next(clazz);
    }

    getClassData() {
        return this._classData;
    }

    private _classesForReorder = new BehaviorSubject<any>([]);
    classesForReorder = this._classesForReorder.asObservable();

    setClassesForReorder(classes) {
        this._classesForReorder.next(classes);
    }

    getClassesForReorder() {
        return this._classesForReorder;
    }

    // getAllGrades() {
    //     console.log('get grades from grades');
    //     return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`);
    // }

    getGrade(gradeId) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}`)
    }

    createGrade(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades`, body)
    }

    updateGrade(body, gradeId) {
        return this.http.put(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}`, body);
    }

    updateGradesSorting(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades/reorder`, body);
    }

    updateClassSorting(body) {
        return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/classes/reorder`, body);
    }

    deleteGrade(gradeId) {
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/grades/${gradeId}`)
    }

    createClass(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/classes`, body)
    }

    updateClass(body, classId) {
        return this.http.put(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/classes/${classId}`, body)
    }

    deleteClass(classId) {
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/classes/${classId}`);
    }

    getSingleClass(classId) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/classes/${classId}`);
    }
}